module.exports = __webpack_public_path__ + "static/media/jump.d49591dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jump.jpg
// module id = 208
// module chunks = 0